import { useMemo, useState } from 'react';

import { getStandards } from 'sdk';

import { buildFilters } from 'utils/filters';
import { useFetch } from 'utils/sdk';

export const useStandards = (selectedStandardsIds) => {
  const [standardSearchValue, setStandardSearchValue] = useState('');

  const params = useMemo(
    () =>
      buildFilters({
        search: standardSearchValue,
        'exclude_standards[]': selectedStandardsIds
      }),
    [standardSearchValue, selectedStandardsIds]
  );

  const {
    data: { results: standards },
    loading: standardsLoading
  } = useFetch(getStandards, { data: { results: [] } }, params);

  return {
    standards,
    setStandardSearchValue,
    standardSearchValue,
    standardsLoading
  };
};
